import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

const buttonWrapper = style({
  display: 'flex',
  padding: 16,
  borderTop: `1px solid ${CommonStyles.Colors.Grey203}`,
});

const rightAlignButtonStyle = style({
  marginLeft: 'auto',
});

export interface LinkedTasksDialogFooterProps {
  addNextTask: () => void;
  cancel: () => void;
  createTask: () => void;
  editTask: () => void;
  taskActionEnabled?: boolean;
  isEdit: boolean;
}

export function LinkedTasksDialogFooter(props: LinkedTasksDialogFooterProps) {
  const addNextTaskButtonProps: ButtonProps = {
    testId: 'linked-tasks-dialog-add-new-task',
    handleClick: props.addNextTask,
  };
  const cancelButtonProps: ButtonProps = {
    testId: 'linked-tasks-dialog-cancel',
    handleClick: props.cancel,
  };
  const createTasksButtonProps: ButtonProps = {
    buttonType: ButtonType.Primary,
    testId: 'linked-tasks-dialog-create-task',
    style: { marginLeft: `${TabStyles.Spacing.MediumSpace}px` },
    handleClick: props.createTask,
    disabled: !props.taskActionEnabled,
  };
  const editTasksButtonProps: ButtonProps = {
    buttonType: ButtonType.Primary,
    testId: 'linked-tasks-dialog-edit-task',
    style: { marginLeft: `${TabStyles.Spacing.MediumSpace}px` },
    handleClick: props.editTask,
    disabled: !props.taskActionEnabled,
  };
  return (
    <div className={buttonWrapper}>
      <ButtonWidget {...addNextTaskButtonProps}>{Messages.linkedTasksAddNextTask()}</ButtonWidget>
      <div className={rightAlignButtonStyle}>
        <ButtonWidget {...cancelButtonProps}>{Messages.cancel()}</ButtonWidget>
        { props.isEdit ?
          <ButtonWidget {...editTasksButtonProps}>{Messages.linkedTasksApply()}</ButtonWidget> :
          <ButtonWidget {...createTasksButtonProps}>{Messages.linkedTasksCreateTasks()}</ButtonWidget>
        }
      </div>
    </div>
  );
}
